__turbopack_context__.v({
  "container": "NewAuthorContent-module-scss-module__thBLfW__container",
});
